export default __webpack_public_path__ + "static/media/trc-logo.6e6875dc.png";